import { Perks } from 'store/dashboard/types';

export const getPerks = async (): Promise<Perks> => {
  // eslint-disable-next-line global-require
  const perks = await require('../../constants/data/perks.json');

  return perks;
};
